import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAuditLogs } from '../utils/api';

const ACTION_COLORS = {
  CREATE_PROJECT: 'var(--green)', CREATE_PLOT: 'var(--green)',
  UPDATE_PROJECT: 'var(--blue)', UPDATE_PLOT: 'var(--blue)',
  DELETE_PROJECT: 'var(--red)', DELETE_PLOT: 'var(--red)',
};

export default function AdminAudit() {
  const [page, setPage] = useState(1);
  const { data, isLoading } = useQuery({
    queryKey: ['audit', page],
    queryFn: () => getAuditLogs(page),
  });

  return (
    <div style={{ padding: 28 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700 }}>Audit Log</h1>
        <p style={{ color: 'var(--text3)', fontSize: 13, marginTop: 2 }}>Track all admin actions and changes</p>
      </div>

      <div className="card">
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><div className="spinner" /></div>
        ) : !data?.logs?.length ? (
          <div className="empty-state"><p>No audit logs yet.</p></div>
        ) : (
          <>
            <div className="tbl-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Admin</th>
                    <th>Action</th>
                    <th>Entity</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {data.logs.map(log => (
                    <tr key={log.id}>
                      <td className="mono" style={{ fontSize: 11.5, whiteSpace: 'nowrap' }}>
                        {new Date(log.created_at).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                      </td>
                      <td style={{ fontWeight: 500, fontSize: 13 }}>{log.admin_name || '—'}</td>
                      <td>
                        <span style={{
                          fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 20,
                          background: `${ACTION_COLORS[log.action]}22`,
                          color: ACTION_COLORS[log.action] || 'var(--text2)',
                        }}>
                          {log.action}
                        </span>
                      </td>
                      <td style={{ fontSize: 12, color: 'var(--text2)', textTransform: 'capitalize' }}>{log.entity_type}</td>
                      <td style={{ fontSize: 11.5, color: 'var(--text3)', maxWidth: 300 }}>
                        {log.new_values && (
                          <span title={JSON.stringify(log.new_values, null, 2)} style={{ cursor: 'help' }}>
                            {Object.entries(log.new_values).slice(0, 2).map(([k, v]) => `${k}: ${v}`).join(', ')}
                            {Object.keys(log.new_values).length > 2 ? '…' : ''}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {data.pages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: 8, padding: 16, borderTop: '1px solid var(--border)' }}>
                <button className="btn btn-outline btn-sm" disabled={page === 1} onClick={() => setPage(p => p - 1)}>← Prev</button>
                <span style={{ display: 'flex', alignItems: 'center', fontSize: 13, color: 'var(--text3)' }}>
                  Page {page} of {data.pages}
                </span>
                <button className="btn btn-outline btn-sm" disabled={page === data.pages} onClick={() => setPage(p => p + 1)}>Next →</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
